import React from 'react';
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const UToast = React.memo(() => {
    return (
        <ToastContainer autoClose={3000}/>
    );
});

export default UToast;
